/**
 * @generated SignedSource<<70bb67bd76edd2824075701522c47961>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedeemBannerBalanceRefetchQuery$variables = {
  id: string;
};
export type RedeemBannerBalanceRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"RedeemBanner_balance">;
  } | null;
};
export type RedeemBannerBalanceRefetchQuery = {
  response: RedeemBannerBalanceRefetchQuery$data;
  variables: RedeemBannerBalanceRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RedeemBannerBalanceRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedeemBanner_balance"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RedeemBannerBalanceRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyAmount",
                "kind": "LinkedField",
                "name": "amount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formatted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subUnitAmount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "WalletBalance",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "974e04fb041d486074329d6de97245d2",
    "id": null,
    "metadata": {},
    "name": "RedeemBannerBalanceRefetchQuery",
    "operationKind": "query",
    "text": "query RedeemBannerBalanceRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...RedeemBanner_balance\n    id\n  }\n}\n\nfragment RedeemBanner_balance on WalletBalance {\n  amount {\n    formatted\n    subUnitAmount\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "81b00572b4fd7013c62281d5f96bcb8b";

export default node;
